import PubSub, { Message } from "../../Utils/pubSub";
import saveSession from "./session";

const memoryStorage = {};

function getItem(key) {
  return new Promise((resolve) => {
    if (memoryStorage[key]) {
      resolve(memoryStorage[key].payload);
      return;
    }

    const sub = PubSub.subscribe(Message.StorageGetSuccess(key), async ({ value }) => {
      if (value) {
        const { id, payload } = await saveSession({ id: value });
        memoryStorage[key] = { id, payload }

        if (value !== id) {
          PubSub.publish(Message.StorageSet, { key, value: id });
        }
        resolve(memoryStorage[key].payload);
      } else {
        memoryStorage[key] = {};
        resolve(null);
      }

      sub.unsubscribe();
    })
    PubSub.publish(Message.StorageGet, { key });
  })
}

function setOnStorage(key, data) {
  return new Promise(async (resolve) => {
    if (!memoryStorage[key]) {
      resolve(data);
      return;
    }

    const { id, payload } = await saveSession({
      id: memoryStorage[key].id,
      payload: data
    });

    PubSub.publish(Message.StorageSet, { key, value: id });
    memoryStorage[key] = { id, payload }
    resolve(memoryStorage[key].payload);
  })
}

const index = {
  getItem: (key) => getItem(key),
  setItem: (key, value) => setOnStorage(key, value),
  removeItem: (key) => setOnStorage(key, null),
}

export default index;
